import { IEditBehavior } from "./IEditBehavior";

export interface IEditBehaviorSpecifiable {
  editBehavior: IEditBehavior;
}

export function instanceOfIEditBehaviorSpecifiable(instance: any): instance is IEditBehaviorSpecifiable {
  return instance
    && (instance.editBehavior !== undefined);
}
